import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const regionImporterSelectors = importerSelectors(
  'region.importer',
);

export default regionImporterSelectors;
